<script>
import { EventBus } from "../../../event-bus.js";
export default {
    name: "MenuDisclaimer",
}

</script>
<style lang="sass">
@import ../../../common/styles/settings
@import MenuDisclaimer
</style>

